<template>
  <div class="grid gap-4 md:grid-cols-2 md:gap-8 md:items-center lg:grid-cols-3">
    <div class="space-y-4 order-2 md:order-1">
      <p
        v-if="primaryTag"
        class="uppercase font-semibold hover:text-secondary"
      >
        <NuxtLink
          :to="
            localePath({
              name: 'category-slug',
              params: {
                slug: primaryTag.slug,
              },
            })
          "
        >
          {{ primaryTag.name }}
        </NuxtLink>
      </p>

      <THeading
        :level="3"
        class="hover:text-secondary"
      >
        <NuxtLink :to="postLink">
          {{ post.title }}
        </NuxtLink>
      </THeading>

      <p class="line-clamp-3">
        {{ post.custom_excerpt || post.excerpt }}
      </p>

      <NuxtLink
        :to="postLink"
        class="text-secondary hover:underline"
      >
        {{ t('actions.readMore') }}
      </NuxtLink>
    </div>

    <div class="rounded-lg overflow-hidden order-1 md:order-2 lg:col-span-2">
      <NuxtLink
        :to="postLink"
        :title="post.title"
      >
        <img
          :src="post.feature_image ?? ''"
          :alt="post.title"
          loading="lazy"
          class="object-cover"
        >
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PostOrPage } from '@tryghost/content-api'

const props = defineProps<{
  post: PostOrPage
}>()

const { t } = useI18n()
const runtimeConfig = useRuntimeConfig()
const localePath = useLocalePath()

const primaryTag = computed(() => {
  let { tags } = props.post

  if (!tags || !tags.length) {
    return null
  }

  tags = tags.filter((tag) => !runtimeConfig.public.locales.includes(tag.slug ?? ''))

  if (!tags.length) {
    return null
  }

  return tags[0]
})

const postLink = computed(() => {
  return localePath({
    name: 'blog-slug',
    params: {
      slug: props.post.slug,
    },
  })
})
</script>
